import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 24px;\n  border-bottom: 1px solid ",
        ";\n  background-color: white;\n  margin: 0 -100%;\n  padding: 0 100%;\n\n  li {\n    padding: 13px 0;\n    border-bottom: none;\n    border-radius: 4px 4px 0 0;\n    cursor: pointer;\n\n    div {\n      color: ",
        ";\n      line-height: 38px;\n    }\n\n    &.active {\n      border-bottom: 2px solid ",
        ";\n      padding: 13px 0 11px;\n      font-weight: 600;\n\n      div {\n        transition: color 0.2s;\n        color: ",
        ";\n      }\n    }\n\n    &.disabled {\n      pointer-events: none;\n      cursor: not-allowed;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
export const ActiveTab = (param)=>{
    let { tabList , activeTab , setActiveTab  } = param;
    return /*#__PURE__*/ _jsx(ActiveTabWrapper, {
        className: "active-tab-wrapper",
        children: tabList.map((tab)=>{
            return /*#__PURE__*/ _jsx("li", {
                onClick: ()=>setActiveTab(tab.key),
                className: "".concat(activeTab === tab.key ? "active" : "", " ").concat(tab.disabled ? "disabled" : ""),
                children: tab.label
            }, "active-tab-".concat(tab.key));
        })
    });
};
const ActiveTabWrapper = styled.ul.withConfig({
    componentId: "sc-db3249ec-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_100, (props)=>props.theme.new.colors.sol_gray_400, (props)=>props.theme.new.colors.sol_gray_800, (props)=>props.theme.new.colors.sol_gray_800);
